import "./Contact.scss";
import { useTranslation } from "react-i18next";
import { useState, useEffect, useMemo, useRef } from "react";
import Button from "../Button/Button";
import { useUID } from "../../context/UIDContext";
import { useAmplitude } from "../../context/AmplitudeContext";
import { useCountries } from "use-react-countries";
import parsePhoneNumber from "libphonenumber-js";

export const Contact = ({ updateUserInfo }) => {
  const { t } = useTranslation("questionsModule");
  const { countries } = useCountries();
  const sortedCountries = useMemo(() => {
    return [...countries]
      .filter((country) => country.name !== "Afghanistan")
      .sort((a, b) =>
        a.name.localeCompare(b.name, undefined, {
          sensitivity: "base",
        }),
      );
  }, [countries]);

  const dropdownRef = useRef(null);
  const [country, setCountry] = useState({
    name: "South Africa",
    code: "+27",
    flag: "https://flagcdn.com/w320/za.png",
  });
  const [open, setOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");

  const { uid } = useUID();
  const trackEvent = useAmplitude();

  const handleNumberChange = (e) => {
    const onlyNumbers = e.target.value.replace(/[^0-9]/g, "");
    const limitedNumbers = onlyNumbers.slice(0, 15);
    setPhoneNumber(limitedNumbers);
  };

  // Check the user comes to email page
  useEffect(() => {
    trackEvent("visited_contact_page", uid);
  }, [uid, trackEvent]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const phoneParseNumber = parsePhoneNumber(`${country.code}${phoneNumber}`);

  return (
    <>
      <div className="contact-module-top-background">
        <img
          className="contact-module-background-image"
          src="images/curl-yellow.png"
          alt="Yellow Curl"
          width={100}
        />
      </div>
      <div className="contact-module-header">
        <h4 className="contact-title">Phone number</h4>
        <p className="contact-info">{t("phone-detail")}</p>
      </div>
      <div className="contact-module-input-wrapper">
        <div className="phone-input" ref={dropdownRef}>
          <div
            className="selector"
            onClick={() => setOpen((prevValue) => !prevValue)}
          >
            <img src={country.flag} className="flag" alt="Country" />
            <span className="code">{country.code}</span>
            <span className="arrow">▾</span>
          </div>

          <input
            className="input"
            value={phoneNumber}
            onChange={handleNumberChange}
            inputMode="numeric"
            pattern="[0-9]*"
          />

          {open && (
            <div className="dropdown">
              {sortedCountries.map((c) => (
                <div
                  key={c.name}
                  className="item"
                  onClick={() => {
                    setCountry({
                      name: c.name,
                      code: c.countryCallingCode,
                      flag: c.flags.png,
                    });
                    setOpen(false);
                  }}
                >
                  <img src={c.flags.png} className="flag" alt="Country" />
                  <span className="name">{c.name}</span>
                  <span className="itemCode">{c.countryCallingCode}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="question-module-btn-wrapper-top">
        <Button
          text={t("skip")}
          onClick={() => {
            trackEvent("pressed_skip_contact_page", uid);
            updateUserInfo({ contact: "" });
          }}
          usePrimaryColor={false}
        />
      </div>
      <div className="question-module-btn-wrapper-bottom">
        <Button
          text={t("continue")}
          onClick={() => {
            trackEvent("pressed_continue_contact_page", uid);
            updateUserInfo({ contact: `${country.code}${phoneNumber}` });
          }}
          disabled={!phoneParseNumber || !phoneParseNumber.isPossible()}
        />
      </div>
    </>
  );
};
